// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LotSummaryChartsQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
  projectIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type LotSummaryChartsQuery = { __typename?: 'Query', developmentLotSummaryCharts?: { __typename?: 'DevelopmentLotSummaryChartsResult', totalAcquired: number, totalPermitSubmitted: number, totalPermitReceived: number, totalVerticalMobilization: number, totalVerticalComplete: number, totalDelivered: number, development: { __typename?: 'Development', id: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string }> | null | undefined }, acquired: Array<{ __typename?: 'CohortLotSummaryChart', total: number, cohort: { __typename?: 'Cohort', id: string, name: string } }>, permitSubmitted: Array<{ __typename?: 'CohortLotSummaryChart', total: number, cohort: { __typename?: 'Cohort', id: string, name: string } }>, permitReceived: Array<{ __typename?: 'CohortLotSummaryChart', total: number, cohort: { __typename?: 'Cohort', id: string, name: string } }>, verticalMobilization: Array<{ __typename?: 'CohortLotSummaryChart', total: number, cohort: { __typename?: 'Cohort', id: string, name: string } }>, verticalComplete: Array<{ __typename?: 'CohortLotSummaryChart', total: number, cohort: { __typename?: 'Cohort', id: string, name: string } }>, delivered: Array<{ __typename?: 'CohortLotSummaryChart', total: number, cohort: { __typename?: 'Cohort', id: string, name: string } }> } | null | undefined };

export type CohortLotSummaryChartFragment = { __typename?: 'CohortLotSummaryChart', total: number, cohort: { __typename?: 'Cohort', id: string, name: string } };

export const CohortLotSummaryChartFragmentDoc = gql`
    fragment CohortLotSummaryChart on CohortLotSummaryChart {
  cohort {
    ...Named
  }
  total
}
    ${NamedFragmentDoc}`;
export const LotSummaryChartsDocument = gql`
    query LotSummaryCharts($developmentId: ID!, $projectIds: [ID!]) {
  developmentLotSummaryCharts(id: $developmentId, projectIds: $projectIds) {
    development {
      id
      cohorts {
        ...Named
      }
    }
    acquired {
      ...CohortLotSummaryChart
    }
    permitSubmitted {
      ...CohortLotSummaryChart
    }
    permitReceived {
      ...CohortLotSummaryChart
    }
    verticalMobilization {
      ...CohortLotSummaryChart
    }
    verticalComplete {
      ...CohortLotSummaryChart
    }
    delivered {
      ...CohortLotSummaryChart
    }
    totalAcquired
    totalPermitSubmitted
    totalPermitReceived
    totalVerticalMobilization
    totalVerticalComplete
    totalDelivered
  }
}
    ${NamedFragmentDoc}
${CohortLotSummaryChartFragmentDoc}`;

/**
 * __useLotSummaryChartsQuery__
 *
 * To run a query within a React component, call `useLotSummaryChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotSummaryChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotSummaryChartsQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *      projectIds: // value for 'projectIds'
 *   },
 * });
 */
export function useLotSummaryChartsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotSummaryChartsQuery, LotSummaryChartsQueryVariables> & ({ variables: LotSummaryChartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>(LotSummaryChartsDocument, options);
      }
export function useLotSummaryChartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>(LotSummaryChartsDocument, options);
        }
// @ts-ignore
export function useLotSummaryChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>;
export function useLotSummaryChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LotSummaryChartsQuery | undefined, LotSummaryChartsQueryVariables>;
export function useLotSummaryChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>(LotSummaryChartsDocument, options);
        }
export type LotSummaryChartsQueryHookResult = ReturnType<typeof useLotSummaryChartsQuery>;
export type LotSummaryChartsLazyQueryHookResult = ReturnType<typeof useLotSummaryChartsLazyQuery>;
export type LotSummaryChartsSuspenseQueryHookResult = ReturnType<typeof useLotSummaryChartsSuspenseQuery>;
export type LotSummaryChartsQueryResult = ApolloReactCommon.QueryResult<LotSummaryChartsQuery, LotSummaryChartsQueryVariables>;